// src/components/Episodes/EpisodeRail.jsx
// Literal markup match of the reference's .a-rail-label/.a-rail/.a-card/
// .a-thumb (4-col grid, collapsing to 2-col at 1100px and a horizontal
// scroll-snap rail at 700px — see EpisodeRail.css). Rendered inside
// HomeTemplate's <section class="a-section a-section--episodes" id="episodes">.
// Kept separate from EpisodeCard (used on the /episodes listing page) so
// this restyle doesn't change that page.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchEpisodes } from '../../api';
import EpisodeCard from './EpisodeCard';
import './EpisodeRail.css';

const RAIL_LIMIT = 4;

const EpisodeRail = () => {
  const [episodes, setEpisodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    fetchEpisodes()
      .then((data) => {
        if (!isMounted) return;
        const list = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
        setEpisodes(list.slice(0, RAIL_LIMIT));
      })
      .catch((err) => {
        console.error('Failed to load episode rail:', err);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!loading && episodes.length === 0) {
    return null;
  }

  return (
    <>
      <div className="a-rail-label">
        <h3>Recent Episodes</h3>
        <Link to="/episodes">See all →</Link>
      </div>
      <div className="a-rail">
        {loading
          ? Array.from({ length: 4 }).map((_, i) => (
              <div className="a-card a-card--skeleton" key={i} />
            ))
          : episodes.map((episode) => <EpisodeCard key={episode.id} episode={episode} />)}
      </div>
    </>
  );
};

export default EpisodeRail;
